export const generateRandomUUID = () => {
  if (ENV.DEV_HOST === 'what-ability-fe.dev.test') {
    const template = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx';
    return template.replace(/[x]/g, function () {
      const randomHex = Math.floor(Math.random() * 16).toString(16);
      return randomHex;
    });
  }
  return crypto.randomUUID();
};
